<template>
  <router-link :to="deviceRoute">
    <el-card>
      <div class="device-container">
        <div class="device-container-info">
          <div class="device-container-info-top">
            <img v-if="appIcon" class="application-icon" :src="appIcon" />
            <div v-else class="application-blank-icon" />

            <div class="device-container-info-top-right">
              <div class="device-name">
                {{ device.application_name }}
              </div>
              <div class="device-model">
                {{ $t('Profiles_Devices_Field_On') }}
                {{ itemDesc }}
              </div>
            </div>
          </div>
          <div class="device-container-info-bottom">
            <el-tag
              size="mini"
              :type="device.active === 1 ? 'success' : 'info'"
              effect="plain"
            >
              {{
                device.active === 1
                  ? $t('Profiles_Devices_Field_StatusActive')
                  : $t('Profiles_Devices_Field_StatusInactive')
              }}
            </el-tag>
            <el-tag
              size="mini"
              effect="plain"
              class="device-authorised-tag"
              v-if="$hasFeature('allowAuthorisedDevices') && device.authorised"
            >
              {{ $t('Profiles_Devices_Field_Authorised') }}
            </el-tag>
            <div class="device-id">
              {{ $t('Profiles_Devices_Field_Id') }} :
              {{ device.id }}
            </div>
          </div>
        </div>

        <div class="device-container-image">
          <img v-if="deviceImage" :src="deviceImage" class="device-image" />
          <img v-else-if="osImage" :src="osImage" class="os-image" />
          <img v-else :src="blankImage" class="blank-image" />
        </div>
      </div>
    </el-card>
  </router-link>
</template>

<script>
import { deviceDescription } from '@/modules/devices/helpers'
import { projectRoute } from '@/core/helpers'

export default {
  name: 'DevicePreviewCard',

  props: {
    device: {
      type: Object,
      required: true
    }
  },

  computed: {
    deviceRoute() {
      return projectRoute({
        name: 'Device',
        query: {
          device_id: this.device.id,
          profile_id: this.device.profile_id
        }
      })
    },

    itemDesc() {
      return deviceDescription(this.device)
    },

    appIcon() {
      return this.device.application_icon
    },

    deviceImage() {
      return this.device.device_image
    },

    osImage() {
      return this.device.os_logo
    },

    blankImage() {
      return require('@/img/devices/image-not-available.png')
    }
  }
}
</script>

<style scoped>
>>> .el-card {
  margin-bottom: 16px;
  border: 1px solid #dbdee7;
  background: #f8fafc;
}

>>> .el-card:hover {
  background: #f2f5f9;
}

>>> .el-card__body {
  padding: 0;
}

.application-icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
}

.application-blank-icon {
  width: 40px;
  height: 40px;
  border-radius: 4px;
  background: #c0c4cc;
}

.device-container {
  height: 116px;
  display: flex;
  align-items: center;
}

.device-container-image {
  width: 136px;
  min-width: 136px;
  height: 116px;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  border-left: 1px solid #dbdee7;
}

.device-image {
  position: absolute;
  top: 16px;
  left: 24px;
  width: 90px;
}

.os-image {
  position: absolute;
  top: 8px;
  left: 18px;
  height: 100px;
  width: 100px;
}

.blank-image {
  position: absolute;
  top: 8px;
  left: 18px;
  height: 100px;
  width: 100px;
}

.device-container-info {
  margin-left: 20px;
  flex: 1;
  min-width: 0;
}

.device-container-info-top {
  display: flex;
  height: 40px;
  margin-bottom: 20px;
}

.device-container-info-bottom {
  display: flex;
  align-items: center;
}

.device-container-info-top-right {
  flex: 1;
  min-width: 0;
  margin-left: 20px;
  margin-top: -4px;
}

.device-name {
  color: #4b515f;
  font-weight: 600;
  font-size: 18px;
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.device-name p {
  overflow: hidden;
  text-overflow: ellipsis;
}

.device-model {
  color: #4b515f;
  font-size: 12px;
  line-height: 18px;
}

.device-id {
  margin-left: 20px;
  font-size: 14px;
  line-height: 22px;
  color: #7e8596;
}

.device-authorised-tag {
  margin-left: 10px;
  border-color: #b3d8ff;
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/modules/devices/components/DevicePreviewCard.vue